var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02751 6.57253L21.9389 2.08632L39.8697 6.5774C39.9427 6.93219 40.027 7.35872 40.1171 7.84604C40.4031 9.39282 40.7459 11.5402 40.974 13.9429C41.4406 18.857 41.3818 24.4279 39.7245 28.2097C37.7072 32.8129 35.9803 35.196 32.1658 38.2674C30.3344 39.7421 27.5593 41.5281 25.1774 42.9776C23.9995 43.6945 22.9405 44.3155 22.1762 44.757C22.0709 44.8179 21.9712 44.8753 21.8776 44.9291C21.7475 44.8632 21.6059 44.7911 21.454 44.7134C20.599 44.2759 19.4202 43.6604 18.125 42.9482C15.49 41.4993 12.529 39.7343 10.7741 38.2838C7.32849 35.4359 6.02856 32.889 4.17835 28.2695C2.62536 24.3921 2.57573 18.7824 3.0081 13.884C3.21993 11.4841 3.53819 9.34439 3.80369 7.80483C3.88497 7.33351 3.96112 6.91945 4.02751 6.57253Z",
    fill: "white",
    stroke: "#A9D1FF",
    strokeWidth: 4.04762
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91261 10.1191L21.742 6.74609L35.5713 10.1191C35.5713 10.1191 38.2202 20.761 35.5713 26.6469C34.0684 29.9866 32.7192 31.8078 29.8372 34.0675C27.1005 36.2133 21.742 39.127 21.742 39.127C21.742 39.127 15.6725 36.241 12.9721 34.0675C10.2718 31.8941 9.24679 29.8907 7.91261 26.6469C5.45741 20.6776 7.91261 10.1191 7.91261 10.1191Z",
    fill: "url(#paint0_linear_574_141735)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_574_141735",
    x1: 21.7419,
    y1: 6.74609,
    x2: 21.7419,
    y2: 39.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1EABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#40D986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#3ED886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.94351ccb31c6b200965546ebafdf934e.svg";
export { ForwardRef as ReactComponent };